<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 78.64 78.64">
  <path
    d="M60.72 61.5l-44.32 -11.68c-1.78,-0.47 -2.48,-2.8 -0.87,-4.15l31.36 -28.11c1.28,-1.15 3.31,-0.58 3.83,1.04l12.85 39.88c0.58,1.79 -1.07,3.49 -2.86,3.02zm-38.86 -15.15l35.88 9.45 -10.4 -32.28 -25.47 22.83z" fill="currentColor" />
  <circle cx="17" cy="47.53" r="9.55" fill="currentColor" />
  <circle cx="61.32" cy="59.21" r="9.55" fill="currentColor" />
  <circle style="fill: currentColor" cx="48.47" cy="19.32" r="9.55"/>
</svg>
